import { createPortal } from 'react-dom'
import FilterModal from '../../../../assets/frontend/js/components/FilterModal'
import { CustomSearchFilter } from '../../../../assets/frontend/js/components/SearchFilter'
import GroupFilter from '../../../../assets/frontend/js/components/GroupFilter'
import { memo, useRef } from 'react'
import { _x } from '@wordpress/i18n'
import { WP_LOCALE } from '../../../../assets/utils/algolia/algoliaLocalization'
import { useConfigContext } from './ConfigContext'
import TagFilter from '../../../../assets/frontend/js/components/TagFilter'
import FilterToggle from '../../../../assets/frontend/js/components/FilterToggle'
import LayoutToggle from '../../../../assets/frontend/js/components/LayoutToggle'
import classNames from 'classnames'
import { useDisplayController } from '../../../../assets/frontend/js/hooks/dom'

type FilterPanelProps = {
  layout: 'card' | 'list'
  onLayoutChange: (layout: 'card' | 'list') => void
  collapsed: boolean
  isDesktop: boolean
}

const FilterPanel = memo(function FilterPanel(props: FilterPanelProps) {
  const { icons: groupIcons } = useConfigContext()

  const filterBarRef = useRef<HTMLDivElement>(null)

  useDisplayController(filterBarRef)

  return (
    <>
      <div className="filter-panel" data-bs-theme="dark">
        <div>
          <CustomSearchFilter
            placeholder={_x(
              'Which sermon are you looking for?',
              'Sermons List Search Filter Placeholder',
              'icf'
            )}
          />
        </div>
        <div
          ref={filterBarRef}
          className={classNames('filter-bar', {
            show: !props.collapsed
          })}
        >
          <div className="filter-bar__content">
            <GroupFilter
              ariaLabel={_x(
                'Filter by group',
                'Sermons List Group Filter ARIA Label',
                'icf'
              )}
              attribute={`group.title.${WP_LOCALE}`}
              icons={groupIcons}
            />
            <div className="filter-panel-button-group d-none d-md-flex ms-auto">
              <FilterToggle variant="desktop" />
              <LayoutToggle
                variant="desktop"
                value={props.layout}
                onChange={props.onLayoutChange}
              />
            </div>
          </div>
        </div>
      </div>
      {createPortal(
        <FilterModal title={_x('Filter Sermons', 'Filter Modal Title', 'icf')}>
          <div className="filter-modal-filter-section filter-modal-filter-section--with-divider">
            <TagFilter
              attribute={`speakers.fullName.${WP_LOCALE}`}
              limit={5}
              title={_x('Speaker', 'Filter Modal Filter Title', 'icf')}
              ariaLabel={_x(
                'Filter by speaker',
                'Filter Modal Filter ARIA Label',
                'icf'
              )}
            />
          </div>
          <div className="filter-modal-filter-section filter-modal-filter-section--with-divider">
            <TagFilter
              attribute={`series.title.${WP_LOCALE}`}
              limit={5}
              title={_x('Series', 'Filter Modal Filter Title', 'icf')}
              ariaLabel={_x(
                'Filter by series',
                'Filter Modal Filter ARIA Label',
                'icf'
              )}
            />
          </div>
          <div className="filter-modal-filter-section">
            <TagFilter
              attribute="year"
              limit={5}
              title={_x('Year', 'Filter Modal Filter Title', 'icf')}
              ariaLabel={_x(
                'Filter by year',
                'Filter Modal Filter ARIA Label',
                'icf'
              )}
            />
          </div>
        </FilterModal>,
        document.body
      )}
    </>
  )
})

export default FilterPanel
